import { render, staticRenderFns } from "./OrderHistoryDetails.vue?vue&type=template&id=6c0b6780&scoped=true"
import script from "./OrderHistoryDetails.vue?vue&type=script&lang=js"
export * from "./OrderHistoryDetails.vue?vue&type=script&lang=js"
import style0 from "./OrderHistoryDetails.vue?vue&type=style&index=0&id=6c0b6780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0b6780",
  null
  
)

export default component.exports